import styled from 'styled-components';

export const TertiaryButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    border-radius: 4px;
    border: 0px;
    font-weight: 600;
    font-size: 14px;
    padding: 0 20px;

    color: var(--button-bg);
    background: rgba(var(--button-bg-rgb), 0.08);

    &:disabled {
        color: rgba(var(--center-channel-color-rgb), 0.32);
        background: rgba(var(--center-channel-color-rgb), 0.08);
    }

    &:hover:enabled {
        background: rgba(var(--button-bg-rgb), 0.12);
    }

    &:active:enabled  {
        background: rgba(var(--button-bg-rgb), 0.16);
    }

    i {
        display: flex;
        font-size: 18px;

        &:before {
            margin: 0 7px 0 0;
        }
    }
`;

export const DestructiveButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    font-weight: 600;
    font-size: 14px;

    padding: 0 20px;

    border-radius: 4px;
    border: 0px;

    background: var(--dnd-indicator);
    color: var(--button-color);

    :hover:enabled {
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.08)), var(--dnd-indicator);
    }

    :active, :hover:active {
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.16), rgba(0, 0, 0, 0.16)), var(--dnd-indicator);
    }

    :disabled {
        background: rgba(var(--center-channel-color-rgb), 0.08);
    }
`;
